export const VEHICLE_CATEGORIES_RESET_STATE = 'VEHICLE_CATEGORIES_RESET_STATE';
export const VEHICLE_CATEGORIES_CURRENT_ITEM = 'VEHICLE_CATEGORIES_CURRENT_ITEM';

export const VEHICLE_CATEGORIES_REQUEST_LOADING = 'VEHICLE_CATEGORIES_REQUEST_LOADING';
export const VEHICLE_CATEGORIES_REQUEST_SUCCESS = 'VEHICLE_CATEGORIES_REQUEST_SUCCESS';
export const VEHICLE_CATEGORIES_REQUEST_FAILED = 'VEHICLE_CATEGORIES_REQUEST_FAILED';

export const VEHICLE_CATEGORIES_CURRENT_ACTION = 'VEHICLE_CATEGORIES_CURRENT_ACTION';
export const VEHICLE_CATEGORIES_RESET_ACTION = 'VEHICLE_CATEGORIES_RESET_ACTION';